import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
const values = [{
  title: 'Do it right.',
  description: "Cutting corners always catches up with you. I'd rather take the extra time and know the work holds up."
}, {
  title: 'Sweat the details.',
  description: 'In law, the small stuff is the stuff. One misread clause or missed deadline can change everything, so I pay attention.'
}, {
  title: 'Show up for people.',
  description: "Whatever side of a case you're on, there's a real person behind it. That's something I try not to lose sight of."
}];
export function Values() {
  return <section className="py-20 md:py-32 px-6 bg-cream-dark/30" data-id="element-126">
      <div className="max-w-6xl mx-auto" data-id="element-127">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20 items-start" data-id="element-128">
          {/* Left: anchor quote */}
          <FadeIn className="lg:col-span-5 lg:sticky lg:top-24" data-id="element-129">
            <span className="text-sage font-medium tracking-widest uppercase text-xs mb-6 block" data-id="element-130">
              How I Work
            </span>
            <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-charcoal italic leading-tight" data-id="element-131">
              "How you do anything
              <br data-id="element-132" />
              is how you do
              <br data-id="element-133" />
              <span className="text-amber" data-id="element-134">everything.</span>"
            </h2>
            <div className="h-px w-16 bg-amber/40 mt-8" data-id="element-135" />
            <p className="text-charcoal/60 text-sm font-light mt-4 max-w-xs" data-id="element-136">
              Three principles I try to hold to, in legal work and everywhere
              else.
            </p>
          </FadeIn>

          {/* Right: connected list of principles */}
          <div className="lg:col-span-7 relative" data-id="element-137">
            {/* Connecting vertical line */}
            <div className="absolute left-[14px] top-2 bottom-2 w-px bg-amber/20" data-id="element-138" />

            <StaggerContainer className="space-y-12" data-id="element-139">
              {values.map((value, idx) => <StaggerItem key={idx} className="relative pl-12" data-id="element-140">
                  {/* Numbered marker */}
                  <div className="absolute left-0 top-0 w-[30px] h-[30px] rounded-full bg-cream border border-amber/40 flex items-center justify-center font-playfair text-amber text-sm" data-id="element-141">
                    {idx + 1}
                  </div>
                  <h3 className="font-playfair text-xl md:text-3xl text-charcoal mb-3" data-id="element-142">
                    {value.title}
                  </h3>
                  <p className="text-charcoal/70 font-light leading-relaxed text-base md:text-lg" data-id="element-143">
                    {value.description}
                  </p>
                </StaggerItem>)}
            </StaggerContainer>
          </div>
        </div>
      </div>
    </section>;
}